module.exports = __webpack_public_path__ + "img/ordered.040849a5.svg";